import React from 'react';
import { theme } from '@triumph/shared';

const ResponsiveImage = ({ mobile, mobileLarge, tablet, tabletLarge, desktop, alt }) => {
  return (
    <picture>
      {desktop ? (
        <source media={`(min-width: ${theme.breakpoints.desktop}px)`} srcSet={window.encodeURI(desktop)} />
      ) : null}
      {tabletLarge ? (
        <source media={`(min-width: ${theme.breakpoints.tabletLarge}px)`} srcSet={window.encodeURI(tabletLarge)} />
      ) : null}
      {tablet ? (
        <source media={`(min-width: ${theme.breakpoints.tablet}px)`} srcSet={window.encodeURI(tablet)} />
      ) : null}
      {mobileLarge ? (
        <source media={`(min-width: ${theme.breakpoints.mobileEnd}px)`} srcSet={window.encodeURI(mobileLarge)} />
      ) : null}
      <img
        srcSet={window.encodeURI(mobile || mobileLarge || tablet || tabletLarge || desktop)}
        src={window.encodeURI(mobile || mobileLarge || tablet || tabletLarge || desktop)}
        alt={alt}
        data-object-fit
        loading="lazy"
      />
    </picture>
  );
};

export default ResponsiveImage;
